import serialize from 'form-serialize'
import queryString from 'query-string'
import NProgress from 'nprogress'
import gsap from 'gsap'
import debounce from 'lodash/debounce'

import { createEvent, normalizeArrayData } from './_helpers'
import GoogleMap from './GoogleMap'
import { scrollTo } from './initScrollTo'
import { filterOpenedClass } from './_constants'
import { initCssAnimations } from './cssAnimationsObserver'
import initStaggerList from './initStaggerList'
// eslint-disable-next-line import/no-cycle
import { withVue } from './onPageLoad'
import { Location } from './translate/location'
import { translator } from './translate'

const fetchHeaders = new Headers()
fetchHeaders.append('Content-Type', 'application/json')

const paginationParams = ['page', 'direction', 'sort']

export default function ajaxForm(page) {
  page.querySelectorAll('[data-ajax-form]').forEach(form => {
    const slotResults = page.querySelector(
      `[data-ajax-results=${form.dataset.ajaxForm}]`
    )
    const scrollContainer = page.querySelector(
      `[data-scroll-container=${form.dataset.ajaxForm}]`
    )
    const searchParams = new URLSearchParams(window.location.search)

    let updateMapAndCards

    // begin init google map
    let googleMap
    const mapElement = page.querySelector(`
      [data-search-map=${form.dataset.ajaxForm}]`)
    if (
      form.search instanceof HTMLInputElement &&
      form.code instanceof HTMLInputElement &&
      form.bounds instanceof HTMLInputElement &&
      mapElement
    ) {
      let initialBounds = null
      if (searchParams.has('bounds')) {
        try {
          initialBounds = JSON.parse(searchParams.get('bounds'))
        } catch (e) {
          console.error('error while parsing bounds from URL params:', e)
        }
      }
      const onBoundsChange = bounds => {
        form.bounds.value = JSON.stringify(bounds)
        form.search.value = ''
        form.code.value = ''
        googleMap.disableAutoFit = true
        if (updateMapAndCards) {
          updateMapAndCards(true)
        }
      }
      googleMap = new GoogleMap(mapElement, {
        initialBounds,
        onBoundsChange: debounce(onBoundsChange, 150),
      })
      form.search.addEventListener('input', () => {
        form.bounds.value = ''
        googleMap.disableAutoFit = false
      })
    }
    // end init google map

    const formInputs = Array.from(
      form.querySelectorAll('input:not([type="hidden"]), [data-bounds-input]')
    )
    if (form.bounds instanceof HTMLInputElement) {
      formInputs.push(form.bounds)
    }

    function scrollToTop() {
      scrollTo(window.innerWidth < 1024 ? 730 : 0, {
        duration: 0,
        headerOffset: true,
      })
    }

    const fetchCards = searchString => {
      slotResults.classList.add('spinner')
      NProgress.start()
      form.classList.add('busy')
      return fetch(`${form.dataset.route}?${searchString}`, {
        headers: fetchHeaders,
      })
        .then(res => res.text())
        .then(html => {
          const newUrl = searchString ? `?${searchString}` : '?'
          window.history.pushState(null, false, newUrl)
          // eslint-disable-next-line no-use-before-define
          appendHtml(html)
        })
        .catch(e => {
          console.error(e) // don't remove this!
          slotResults.innerHTML = `<p class="error">${slotResults.dataset.errorMessage}</p>`
        })
        .finally(() => {
          slotResults.classList.remove('spinner')
          NProgress.done()
          form.classList.remove('busy')
        })
    }

    const initPagination = container => {
      container.querySelectorAll('.pagination a, .order-by a').forEach(a => {
        a.dataset.barbaPrevent = ''
        a.addEventListener('click', e => {
          e.preventDefault()

          const searchString = a
            .getAttribute('href')
            .split('?')
            .pop()
            .replaceAll(/\%5B\d+\%5D/g, '%5B%5D')
            .replaceAll(/\[\d+\]/g, '[]')

          scrollToTop()
          fetchCards(searchString)
        })
      })
    }

    const appendHtml = html => {
      slotResults.innerHTML = html
      withVue(slotResults, () => {
        initPagination(slotResults)
        initCssAnimations(slotResults)
        initStaggerList(slotResults)
        const location = new Location(slotResults, {
          cache: false
        })
        translator.registerLocation('ajaxForm', location)
        translator.refreshTranslation('ajaxForm')
      })
    }

    updateMapAndCards = forceFirstPage => {
      const pagination = {}
      const currentQuery = queryString.parse(window.location.search)
      paginationParams.forEach(param => {
        if (param in currentQuery) {
          pagination[param] = currentQuery[param]
        }
      })
      if (forceFirstPage) {
        delete pagination.page
      }
      const queryPagination = queryString.stringify(pagination)
      const queryAll = serialize(form)

      const promises = []
      const p1 = fetchCards(
        [queryAll, queryPagination].filter(el => !!el).join('&')
      )
      promises.push(p1)

      // separate query for map - it must display all results without pagination
      if (mapElement && googleMap) {
        mapElement.classList.add('busy')
        const p2 = fetch(`${mapElement.dataset.coordinatesRoute}?${queryAll}`)
          .then(res => res.json())
          .then(json => {
            mapElement.classList.remove('busy')
            googleMap.setMinZoomCircle(
              form.action.value === 'acheter' ? 12 : 999
            )
            googleMap.setMarkers(json)
          })
        promises.push(p2)
      }

      // show / hide things depending on "action" filter (rent or buy)
      page.querySelectorAll('[data-if-action]').forEach(el => {
        let isActive = el.dataset.ifAction === form.action.value
        if ('inverse' in el.dataset) {
          isActive = !isActive
        }
        el.style.display = isActive ? '' : 'none'
      })

      if (forceFirstPage) {
        scrollToTop()
      }

      return Promise.all(promises)
    }

    // const initShowMoreList = () => {
    //   const itemsPerClick = 5
    //   let currentCount = 0
    //
    //   form.querySelectorAll('[data-show-more-list]').forEach(list => {
    //     const showMoreBtn = list.querySelector('[data-show-more-button]')
    //     const hiddenItems = Array.from(list.querySelectorAll(`.${hiddenClass}`))
    //
    //     showMoreBtn.addEventListener('click', () => {
    //       let nextCount = currentCount + itemsPerClick
    //
    //       if (nextCount > hiddenItems.length) {
    //         nextCount = hiddenItems.length
    //
    //         showMoreBtn.style.display = 'none'
    //       }
    //
    //       hiddenItems
    //         .slice(currentCount, nextCount)
    //         .forEach(item => item.classList.remove(hiddenClass))
    //
    //       currentCount = nextCount
    //     })
    //   })
    // }

    const updateChart = () => {
      let maxValue = 0
      const w = 1200
      const h = 200
      const normalizeX = (x, data) => (x / data.length) * w
      const normalizeY = y => (y / maxValue) * h
      const generatePath = data => {
        let d = `M0,0 L0,${normalizeY(data[0])}`
        data.forEach((number, index) => {
          const x = normalizeX(index + 1, data)
          const y = normalizeY(number)
          d += ` L${x},${y}`
          if (data[index + 1] !== undefined) {
            const yNext = normalizeY(data[index + 1])
            d += ` L${x},${yNext}`
          } else if (data[index + 1] === undefined) {
            d += ` L${x},0 Z`
          }
        })

        return d
      }

      form.querySelectorAll('[data-chart]').forEach(chart => {
        chart.setAttribute('viewBox', `0 0 ${w} ${h}`)

        fetch(chart.dataset.route)
          .then(res => res.json())
          .then(data => {
            const normalizedData = normalizeArrayData(data, 10)
            const line = chart.querySelector('[data-chart-line]')

            maxValue = normalizedData.reduce((a, c) => Math.max(a, c), 0)

            gsap.to(line, {
              attr: { d: generatePath(normalizedData) },
              duration: 1,
            })
          })
      })
    }

    const debouncedUpdateChart = debounce(updateChart, 500)

    form
      .querySelectorAll('input:not([data-no-chart-update]),select,textarea')
      .forEach(el =>
        el.addEventListener('change', () => {
          debouncedUpdateChart()
        })
      )

    form.addEventListener('submit', e => {
      e.preventDefault()

      const invalidFields = Array.from(formInputs).filter(input =>
        input.hasAttribute('data-error')
      )

      if (!invalidFields.length) {
        document.documentElement.classList.remove(filterOpenedClass)
        updateMapAndCards(true)
      }
    })

    // sync filters with URL on initial page load
    formInputs.forEach(input => {
      const inputName = input.getAttribute('name')
      if (searchParams.has(inputName)) {
        const inputParams = searchParams.getAll(inputName)
        if (
          (input.type === 'checkbox' || input.type === 'radio') &&
          inputParams.includes(input.value)
        ) {
          input.checked = true
        } else if (input.type !== 'checkbox' && input.type !== 'radio') {
          // eslint-disable-next-line prefer-destructuring
          input.value = inputParams[0]
        }

        if (!input.classList.contains('autocomplete')) {
          input.dispatchEvent(createEvent('input'))
        }
      }
    })

    form.querySelector('[data-advance-open]').addEventListener('click', () => {
      document.documentElement.classList.toggle(filterOpenedClass)
    })

    form.querySelector('[data-reset-form]').addEventListener('click', () => {
      window.dispatchEvent(createEvent('formReset'))

      formInputs.forEach(input => {
        if (input.type === 'checkbox' || input.type === 'radio') {
          input.checked = false
          input.dispatchEvent(createEvent('change'))
        } else if (
          input.type !== 'checkbox' &&
          input.type !== 'radio' &&
          !input.hasAttribute('readonly')
        ) {
          input.value = ''
          input.dispatchEvent(createEvent('change'))
        }
      })
    })

    updateMapAndCards(false)
    // initShowMoreList()
    updateChart()
  })
}
